import { put, delay } from 'redux-saga/effects';
import { fetchDriftPost, fetchNyheterPost, logToApiPost, postBugReportToSupport } from '../../felles/APICalls_SPRING';
import Utils from '../../felles/Utils';
import * as actionsNV03 from "../actions/indexNV03";
import * as actions from '../actions';

const MAX_RETRIES = 5;

export function* getNyheterPost() {
  try {
    yield put(actions.nyheterMeldingStarted());
    let lastError: any;
    for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
      try {
        const rep: any = yield fetchNyheterPost();
        if (rep && rep.data) {
          yield put(actions.nyheterMeldingFetchSuccess(rep.data));
        }
        return;
      } catch (error: any) {
        lastError = error;
        Utils.log(`[getNyheterPost] Error (status: ${error?.response?.status}), attempt ${attempt}/${MAX_RETRIES}`);
        if (attempt === MAX_RETRIES) {
          Utils.log('[getNyheterPost] Max retries reached. Giving up.');
          yield put(actions.nyheterMeldingFetchFailed(error));
          return;
        }
        yield delay(1000 * attempt);
      }
    }
  } catch (error) {
    yield put(actions.nyheterMeldingFetchFailed(error));
  }
}

export function* getDriftPost() {
  try {
    yield put(actions.driftMeldingStarted());
    let lastError: any;
    for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
      try {
        const rep: any = yield fetchDriftPost();
        if (rep && rep.data) {
          yield put(actions.driftMeldingFetchSuccess(rep.data));
        }
        return;
      } catch (error: any) {
        lastError = error;
        Utils.log(`[getDriftPost] Error (status: ${error?.response?.status}), attempt ${attempt}/${MAX_RETRIES}`);
        if (attempt === MAX_RETRIES) {
          Utils.log('[getDriftPost] Max retries reached. Giving up.');
          yield put(actions.driftMeldingFetchFailed(error));
          return;
        }
        yield delay(1000 * attempt);
      }
    }
  } catch (error) {
    yield put(actions.driftMeldingFetchFailed(error));
  }
}

export function* logToApiSaga(action: any) {
  try {
    // Only execute in development mode
    if (import.meta.env.MODE === 'development' || import.meta.env.MODE === 'vm') {
      console.debug('[logToApiSaga] Payload:', action.payload); // Log payload for debugging
      yield logToApiPost(action.payload); // Send log to API
      console.info('[logToApiSaga] Log successfully sent to API.');
    }
  } catch (error) {
    // Log error details
    console.error('[logToApiSaga] Error sending log:', error);
  }
}

export function* bugReportingPostSaga(action) {
  try {
    const resp = yield postBugReportToSupport(action.payload);
    if (resp && resp.data) {
      yield put(actions.setRecordingState(4));
    }
  } catch (error) {
    yield put(actions.setRecordingState(5));
    Utils.log('error sending Bug report');
  }
}

// Reset predefined redux store branches
export function* resetPredefinedReduxTransactionStoreSaga() {
  try {
    //Add more branches to clean up here
    yield put(actionsNV03.NV03ClearComponentStore());
  } catch (error) {
    Utils.log('error cleaning up store branches');
  }
}


